export const NewClassroomActionTypes = {
    TOGGLE_CLASSROOM_PAGE_HIDDEN: 'TOGGLE_CLASSROOM_PAGE_HIDDEN'
};